import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
import LoginView from '../views/LoginView.vue'
import LoginIOSView from '../views/LoginIOSView.vue'
import MensaView from '../views/MensaView.vue'
import Mealplanning from "../components/Mealplanning.vue"
import OfflineView from "../views/OfflineView.vue"
import MaintenanceView from "../views/MaintenanceView.vue"
const routes = [
  {
    path: '/',
    name: 'Home',
    component: MainView
  },
  {
    path: '/offline',
    name: 'Offline',
    component: OfflineView
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: MaintenanceView
  },
  {
    path: '/cards',
    name: 'Mensakarten',
    component: MainView
  },
  {
    path: '/account',
    name: 'Kontoverwaltung',
    component: MainView
  },
  {
    path: '/pickup',
    name: 'Abholung',
    component: MainView
  },  
  {
    path: '/mydata',
    name: 'Meine Daten',
    component: MainView
  }, {
    path: '/book',
    name: 'Leistung buchen',
    component: MainView
  },{
    path: '/services',
    name: 'Meine Leistungen',
    component: MainView
  },  {
    path: '/mealplanning',
    name: 'Essensplanung',
    component: MainView
  },
  {
    path: '/mealplanningframe',
    name: 'EssensplanungFrame',
    component: Mealplanning
  },
  {
    path: '/ehrenamt',
    name: 'Ehrenamt',
    component: MainView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/loginIOS',
    name: 'LoginIOS',
    component: LoginIOSView
  },
  {
    path: '/mensa/monte',
    name: 'mensamonte',
    component: MensaView
  },
  {
    path: '/mensa/erft',
    name: 'mensaerft',
    component: MensaView
  },
  {
    path: '/mensa/gugy',
    name: 'mensagugy',
    component: MensaView
  },
  {
    path: '/mensa/apostel',
    name: 'mensaapostel',
    component: MensaView
  },
  {
    path: '/mensa/schauerte',
    name: 'mensaschauerte',
    component: MensaView
  },
  {
    path: '/mensa/alberteinstein',
    name: 'mensaalberteinstein',
    component: MensaView
  },
  {
    path: '/mensa/erichkaestner',
    name: 'mensaerichkaestner',
    component: MensaView
  },
  {
    path: '/mensa/gesamtbergheim',
    name: 'mensagesamtbergheim',
    component: MensaView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
